import React from "react";
import styled from "@emotion/styled";
import { useTheme } from "@mui/material/styles";

import { Typography } from "@mui/material";

import SidebarNavList from "./SidebarNavList";

const Title = styled(Typography)`
  color: #666;
  font-size: ${(props) => props.theme.typography.caption.fontSize};
  padding: ${(props) => props.theme.spacing(2)} ${(props) => props.theme.spacing(4)}
    ${(props) => props.theme.spacing(0.5)};
  opacity: 0.4;
  text-transform: uppercase;
  display: block;
`;

const SidebarNavSection = (props) => {
  const theme = useTheme();
  const { title, pages, className, component: Component = "nav", collapsed, ...rest } = props;

  return (
    <Component {...rest}>
      {title && !collapsed && (
        <Title variant="subtitle2" theme={theme}>
          {title}
        </Title>
      )}
      <SidebarNavList pages={pages} depth={0} collapsed={collapsed} />
    </Component>
  );
};

export default SidebarNavSection;
